import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import Link from "../../Link";
//image
import { FaCheck, FaTimes } from "react-icons/fa";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import increaseItemStock from "../../../actions/shop/menu/increaseItemStock";
import approveAndSearchDriver from "../../../actions/shop/orders/approveAndSearchDriver";
import { getPendingOrders } from "../../../actions/shop/orders/getPendingOrders";

import updateOrderStatus from "../../../actions/shop/orders/updateOrderStatus";
import { openDeclineReasonModal } from "../../../actions/siteadmin/modalActions";
import { api, toneUploadDir } from "../../../config";
import messages from "../../../locale/messages";
import Loader from "../../Common/Loader";
import rs from "../../storeCommon.css";
import DeclineReasonModal from "../OrderManagement/DeclineReasonModal";
import s from "./OrderAccept.css";
import OrderCountdownTimer from "./OrderCountdownTimer";

const OrderItemList = ({ booking, formatMessage }) => {
	const [expanded, setExpanded] = React.useState(false);
	const { orderItemDetails } = booking;

	if (
		!orderItemDetails ||
		!Array.isArray(orderItemDetails) ||
		orderItemDetails.length === 0
	) {
		return (
			<div>
				{formatMessage(messages.numberOfOrder)}: {booking.orderItemsCount}{" "}
				<a
					href={`/store/order-details/upcoming/${booking.id}`}
					target="_blank"
					className={s.linkColor}
				>
					(<FormattedMessage {...messages.viewDetails} />)
				</a>
			</div>
		);
	}

	const numberOfDisplayedItems = 10;
	const displayItems = expanded
		? orderItemDetails
		: orderItemDetails.slice(0, numberOfDisplayedItems);
	const hasMore = orderItemDetails.length > numberOfDisplayedItems;

	return (
		<div style={{ textAlign: "left", marginTop: "10px" }}>
			<div style={{ fontWeight: "500", marginBottom: "5px" }}>
				Total <b>{booking.orderItemsCount}</b> items:

				<a href={`/store/order-details/upcoming/${booking.id}`}
					className={cx(s.linkColor, "ml-2")}
				>
					(<FormattedMessage {...messages.viewDetails} />)
				</a>
			</div>
			<ul className='list-group'>
				{displayItems.map((item, index) => (
					<li key={item.itemId || index} className='list-group-item'>
						<b className="badge badge-secondary">{item.quantity}x</b> {item.itemName}
					</li>
				))}
			</ul>
			{hasMore && (
				<button
					type="button"
					style={{
						color: "#E62529",
						cursor: "pointer",
						marginBottom: "5px",
						fontWeight: "500",
						background: "transparent",
						border: "none",
						padding: 0,
					}}
					onClick={() => setExpanded(!expanded)}
				>
					{expanded ? "See less" : `See ${orderItemDetails.length - numberOfDisplayedItems} more`}
				</button>
			)}
		</div>
	);
};

class OrderAccept extends React.Component {
	static propTypes = {
		formatMessage: PropTypes.func,
	};

	constructor(props) {
		super(props);
		this.state = {
			play: false,
			loadingState: [],
		};
		this.togglePlay = this.togglePlay.bind(this);
	}

	togglePlay = () => {
		const audioEl = document.getElementById("audio-element");
		this.setState({ play: !this.state.play }, () => {
			this.state.play ? audioEl.play() : audioEl.pause();
		});
	};

	componentDidMount() {
		this.togglePlay();
	}

	async handleBookingStatusChange(id, bookingStatus, orderItemDetails) {
		const { updateOrderStatus, increaseItemStock } =
			this.props;
		this.setState({
			loadingState: {
				...this.state.loadingState,
				[id]: true,
			},
		});
		if (bookingStatus === "approved") {
			await updateOrderStatus(id, bookingStatus, 1, null, null, true);
		} else if (bookingStatus === "declined") {
			await updateOrderStatus(id, bookingStatus, 1, null, null, true);
			await increaseItemStock(orderItemDetails);
		}
		this.setState({
			loadingState: {
				...this.state.loadingState,
				[id]: false,
			},
		});
	}

	async handleAcceptOrder(id) {
		const { approveAndSearchDriver } = this.props;
		await approveAndSearchDriver(id);
	}

	renderMultipleBooking(booking, index) {
		const { orderAcceptInterval, getPendingOrders } = this.props;
		const { loadingState } = this.state;
		const { formatMessage } = this.props.intl;
		const timeDiff =
			parseInt(orderAcceptInterval, 10) -
			parseInt(booking.second_difference, 10);

		if (timeDiff <= 0) {
			return null;
		}

		return (
			<div key={index} className={cx({ 'mt-4': index !== 0 })}>
				{index !== 0 && <hr className="mb-0" />}
				<div className={cx(s.orderId, "p-2")}>
					<span className="badge badge-danger mr-2">{index + 1}</span>
					{formatMessage(messages.orderId)}: #{booking.orderId}
				</div>
				<div className={s.grid}>
					<div>
						Auto Cancel in
					</div>
					<div>
						<OrderCountdownTimer
							initialRemainingTime={timeDiff}
							onComplete={() => getPendingOrders()}
							containerStyle={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								marginTop: "-4px",
							}}
							labelStyle={{
								fontSize: "9px",
								color: "#666",
								marginBottom: "2px",
								textAlign: "center",
								lineHeight: "1",
							}}
							textClassName={s.circleTextCss}
						/>
					</div>
				</div>

				<div className="p-4 d-flex flex-column justify-content-center">
					<div className={s.itemCss}>
						<OrderItemList booking={booking} formatMessage={formatMessage} />
					</div>
					{booking.orderNotes && (
						<div className="alert alert-warning mt-2">
							{booking.orderNotes}
						</div>
					)}
				</div>

				<div className="mt-2 p-4 d-flex justify-content-center">
					<Button
						variant="outline-danger mr-2"
						disabled={loadingState[booking.id]}
						onClick={() =>
							this.handleBookingStatusChange(
								booking.id,
								"declined",
								booking.orderItemDetails,
							)
						}
					>
						<FaTimes className="mr-2" />
						{formatMessage(messages.rejectedLabel)}
					</Button>
					<Button
						variant="success"
						disabled={loadingState[booking.id]}
						onClick={() => this.handleAcceptOrder(booking.id)}
					>
						<FaCheck className="mr-2" />
						{formatMessage(messages.acceptedLabel)}
					</Button>
				</div>
			</div>
		);
	}

	renderSingleBooking(booking, index) {
		const { orderAcceptInterval, getPendingOrders } = this.props;
		const { loadingState } = this.state;
		const { formatMessage } = this.props.intl;
		const timeDiff =
			parseInt(orderAcceptInterval, 10) -
			parseInt(booking.second_difference, 10);

		if (timeDiff <= 0) {
			return null;
		}

		return (
			<div key={index}>
				<div>
					{/* Header */}
					<div className={cx(s.orderId, "p-2")}>
						{formatMessage(messages.orderId)}: #{booking.orderId}
					</div>
				</div>
				<div className={s.timerSection}>
					<div>
						Auto Cancel in
					</div>
					<OrderCountdownTimer
						initialRemainingTime={timeDiff}
						onComplete={() => getPendingOrders()}
						containerStyle={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
						labelStyle={{
							fontSize: "12px",
							color: "#666",
							marginBottom: "2px",
						}}
						textClassName={s.circleText}
					/>
				</div>

				<div className={s.detailsCss}>
					<OrderItemList booking={booking} formatMessage={formatMessage} />
					{booking.orderNotes && (
						<div className="alert alert-warning mt-2">
							{booking.orderNotes}
						</div>
					)}
					<div className="d-flex mt-4 justify-content-center pt-4">
						<Button
							variant="outline-danger"
							size="lg"
							className="mr-4"
							disabled={loadingState[booking.id]}
							onClick={() =>
								this.handleBookingStatusChange(
									booking.id,
									"declined",
									booking.orderItemDetails,
								)
							}
						>
							<FaTimes className="mr-2" />
							{formatMessage(messages.rejectedLabel)}
						</Button>
						<Button
							variant="success"
							size="lg"
							disabled={loadingState[booking.id]}
							onClick={() => this.handleAcceptOrder(booking.id)}
						>
							<FaCheck className="mr-2" />
							{formatMessage(messages.acceptedLabel)}
						</Button>
					</div>
				</div>
			</div>
		);
	}

	render() {
		let { orderLoading, data, requestTone, orderAcceptInterval } = this.props;

		// --- DUMMY DATA FOR DEBUGGING ---
		const isDebug = false; // Set to false to disable dummy data
		if (isDebug) {
			orderLoading = false;
			orderAcceptInterval = orderAcceptInterval || 120;
			data = [
				{
					id: 9991, // dummy id
					second_difference: 5,
					userName: "John Doe",
					orderId: "654321",
					orderItemsCount: 4,
					orderItemDetails: [
						{
							itemId: 101,
							itemName: "Spicy Chicken Burger",
							price: 15000,
							quantity: 2,
							totalWithDiscount: 28000,
							priceWithDiscount: 14000,
							total: 30000,
						},
						{
							itemId: 102,
							itemName: "French Fries Large",
							price: 5000,
							quantity: 1,
							totalWithDiscount: 15000,
							priceWithDiscount: 15000,
							total: 5000,
						},
						{
							itemId: 102,
							itemName: "French Fries Small",
							price: 5000,
							quantity: 1,
							totalWithDiscount: 5000,
							priceWithDiscount: 5000,
							total: 5000,
						},
						{
							itemId: 102,
							itemName: "French Fries Small",
							price: 5000,
							quantity: 1,
							totalWithDiscount: 5000,
							priceWithDiscount: 5000,
							total: 5000,
						},
					],
				},
				// Uncomment below to test multiple orders layout:
				{
					id: 2992,
					second_difference: 15,
					userName: "Jane Smith",
					orderId: "6789",
					orderNotes: "Please make it spicy and no onions",
					orderItemsCount: 2,
					orderItemDetails: [
						{
							itemId: 201,
							itemName: "Margherita Pizza",
							price: 25.0,
							quantity: 1,
							totalWithDiscount: 20.0,
							priceWithDiscount: 20.0,
							total: 25.0,
						},
						{
							itemId: 201,
							itemName: "Margherita Pizza 2",
							price: 25.0,
							quantity: 3,
							totalWithDiscount: 20.0,
							priceWithDiscount: 20.0,
							total: 25.0,
						},
					],
				},
			];
		}
		// --------------------------------

		return (
			<Loader show={orderLoading} type={"page"}>
				<div className={s.padding}>
					<DeclineReasonModal />
					<audio id="audio-element">
						<source
							src={api.apiEndpoint + toneUploadDir + requestTone}
						></source>
						<track kind="captions" />
					</audio>
					{!orderLoading &&
						data &&
						data.length > 1 &&
						data.map((booking, index) =>
							this.renderMultipleBooking(booking, index),
						)}

					{!orderLoading &&
						data &&
						data.length <= 1 &&
						data.map((booking, index) =>
							this.renderSingleBooking(booking, index),
						)}
				</div>
			</Loader>
		);
	}
}

const mapState = (state) => ({
	orderLoading: state.orderData.orderLoading,
	data: state.orderData.data,
	count: state.orderData.count,
	requestTone: state.siteSettings?.data?.requestTimeTone,
	orderAcceptInterval: state.siteSettings?.data?.orderAcceptInterval,
});

const mapDispatch = {
	updateOrderStatus,
	openDeclineReasonModal,
	getPendingOrders,
	increaseItemStock,
	approveAndSearchDriver,
};

export default injectIntl(
	withStyles(s, rs)(connect(mapState, mapDispatch)(OrderAccept)),
);
